// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tutorial_overlay__20obe","container":"tutorial_container__1J8-S","close":"tutorial_close__1evcg","link":"tutorial_link__2Ffsy"};